import { generateApiPath } from "@routes/generatePath";

const pathBase = `/medical-service-provider/reports`;

export const medicalServiceCenters = {
  get: () => generateApiPath(pathBase),
};
